import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectArticle(data) {
  return request({
    url: `/admin/article/select`,
    method: "POST",
    data,
    // isEncrypt:false,
    // isDecrypt:false
  });
}

/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addArticle(data) {
  return request({
    url: `/admin/article/add`,
    method: "POST",
    data,
  });
}

/**
 * 更改
 * @param {*} data
 * @returns
 */
export function updateArticle(data) {
  return request({
    url: `/admin/article/update`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteArticle(data) {
  return request({
    url: `/admin/article/delete`,
    method: "POST",
    data
  });
}
